import { useCallback, useEffect, useRef, useState } from 'react';
export const useScrollShadow = (threshold = 0) => {
    const [scrollState, setScrollState] = useState({
        hasScrolledTop: false,
        hasScrolledBottom: false,
    });
    const viewportRef = useRef(null);
    const rafRef = useRef();
    const checkScrollPosition = useCallback(() => {
        if (viewportRef.current) {
            const element = viewportRef.current;
            const scrollTop = element.scrollTop;
            const scrollHeight = element.scrollHeight;
            const clientHeight = element.clientHeight;
            const hasScrolledTop = scrollTop > threshold;
            const hasScrolledBottom = scrollTop + clientHeight < scrollHeight - threshold;
            setScrollState((prev) => {
                if (prev.hasScrolledTop !== hasScrolledTop ||
                    prev.hasScrolledBottom !== hasScrolledBottom) {
                    return {
                        hasScrolledTop,
                        hasScrolledBottom,
                    };
                }
                return prev;
            });
        }
    }, [threshold]);
    useEffect(() => {
        const el = viewportRef.current;
        if (!el) {
            return () => { };
        }
        const handleScroll = () => {
            if (rafRef.current) {
                cancelAnimationFrame(rafRef.current);
            }
            rafRef.current = requestAnimationFrame(checkScrollPosition);
        };
        checkScrollPosition();
        el.addEventListener('scroll', handleScroll, { passive: true });
        const resizeObserver = new ResizeObserver(() => {
            checkScrollPosition();
        });
        resizeObserver.observe(el);
        return () => {
            el.removeEventListener('scroll', handleScroll);
            resizeObserver.disconnect();
            if (rafRef.current) {
                cancelAnimationFrame(rafRef.current);
            }
        };
    }, [checkScrollPosition]);
    return Object.assign({ viewportRef }, scrollState);
};
//# sourceMappingURL=index.js.map